import { FormErrorMessages } from '../ui/form-components/form-error/form-error-messages';

export class FormValidationUtils {
  public static readonly INVALID_DATE_MARKER = '__INVALID_DATE__';

  public static readonly DEFAULT_FORM_ERROR_MESSAGES: FormErrorMessages = {
    required: $localize`Entry is required`,
    email: $localize`Invalid email address`,
    invalidPhoneNumber: $localize`Invalid phone number`,
    invalidDate: $localize`Invalid date`,
    invalidEmail: $localize`Invalid email address`,
    dateInFuture: $localize`Date cannot be in the future`,
    dateInPast: $localize`Date cannot be in the past`,
    dateRangeInvalid: $localize`End date must be later than start date`,
    invalidSin: $localize`Invalid social insurance number`,
    trusteeIsSpouse: $localize`You must choose a trustee who is not your current spouse`,
    trusteeIsMinor: $localize`The trustee must be 18 or older`
  };
}
